import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationConfigurationService } from "@app/core/services/ApplicationConfiguration.service";
import { IpActivityTimeline } from "../models/ip-activity-timeline.model";

const BASE_PATH = "/api/phms/incarcerated-persons";

const quietHttpOptions = {
  headers: new HttpHeaders({
    "skip-error-interceptor": "yes",
    "skip-loading-interceptor": "yes",
  }),
  withCredentials: true,
};

@Injectable({ providedIn: "root" })
export class IpActivityTimelineService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(ApplicationConfigurationService);

  getActivityTimeline(incarceratedPersonId: number): Observable<IpActivityTimeline> {
    return this.http.get<IpActivityTimeline>(
      this.appConfig.apiUrl(`${BASE_PATH}/${encodeURIComponent(String(incarceratedPersonId))}/activity-timeline`),
      quietHttpOptions,
    );
  }
}
